import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { CustomCursor } from '@/components/ui/CustomCursor'
import { AnimatedFavicon } from '@/components/ui/AnimatedFavicon'
import LandingPage from './page'
import SignInPage from './sign-in/page'
import SignUpPage from './sign-up/page'
import DashboardLayout from './dashboard/layout'
import DashboardOverview from './dashboard/page'
import ModelsPage from './dashboard/models/page'
import KeysPage from './dashboard/keys/page'
import UsagePage from './dashboard/usage/page'
import BillingPage from './dashboard/billing/page'
import PlaygroundPage from './dashboard/playground/page'
import SettingsPage from './dashboard/settings/page'

export default function App() {
  return (
    <>
    <CustomCursor />
    <AnimatedFavicon />
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardOverview />} />
        <Route path="models" element={<ModelsPage />} />
        <Route path="keys" element={<KeysPage />} />
        <Route path="usage" element={<UsagePage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="playground" element={<PlaygroundPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
    </>
  )
}
